export default __webpack_public_path__ + "assets/1ff7782c7049effd8d8bc7e42c08e1be/12.jpg";